/*!
 *
 * site-menu.js
 *
 */
export default function initSiteMenu(header, closeMegaMenus) {
    const menu = header.querySelector('[data-site-menu]');
    const menuButton = header.querySelector('[data-site-menu-button]');
    if (!menu || !menuButton)
        return;
    const closeMenu = () => {
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'メニューを開く');
        menu.removeAttribute('data-open');
        document.body.classList.remove('site-menu-open');
        closeMegaMenus();
    };
    menuButton.addEventListener('click', () => {
        const willOpen = menuButton.getAttribute('aria-expanded') !== 'true';
        menuButton.setAttribute('aria-expanded', String(willOpen));
        menuButton.setAttribute('aria-label', willOpen ? 'メニューを閉じる' : 'メニューを開く');
        if (willOpen)
            menu.setAttribute('data-open', 'true');
        else
            menu.removeAttribute('data-open');
        document.body.classList.toggle('site-menu-open', willOpen);
        if (!willOpen)
            closeMegaMenus();
    });
    const handleMenuLinkActivation = (event) => {
        if (menuButton.getAttribute('aria-expanded') !== 'true')
            return;
        if (!(event.target instanceof Element) || !event.target.closest('a'))
            return;
        closeMenu();
    };
    menu.addEventListener('click', handleMenuLinkActivation, { capture: true });
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape')
            return;
        if (menuButton.getAttribute('aria-expanded') === 'true') {
            closeMenu();
            menuButton.focus();
        }
        else {
            closeMegaMenus();
        }
    });
    window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 992px)').matches)
            closeMenu();
    });
}
